import { render, staticRenderFns } from "./yuyue_list.vue?vue&type=template&id=124e585d&scoped=true&"
import script from "./yuyue_list.vue?vue&type=script&lang=js&"
export * from "./yuyue_list.vue?vue&type=script&lang=js&"
import style0 from "./yuyue_list.vue?vue&type=style&index=0&id=124e585d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e585d",
  null
  
)

export default component.exports